import {
	EuiModalBody,
	EuiModalFooter,
	EuiButton,
} from '@equipmentshare/ds2'

export type DeleteInventoryLocationModalProps = {
	onCancel: () => void,
}

export default function DeleteInventoryLocationModal( { onCancel }: DeleteInventoryLocationModalProps ) {
	return (
		<>
			<EuiModalBody>
				There is existing inventory in this store. You must transfer this inventory to a new location before you can delete.
			</EuiModalBody>
			<EuiModalFooter>
				<EuiButton
					id="confirmBtn"
					fill
					color="primary"
					onClick={onCancel}
				>
					OK
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
